import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import Logo from "../../assets/images/header/SIA Logo.png";
import Image from "next/image";
import { upscprelimsApiserviceget } from "../../components/Service/upscprelims"; 
import { useState, useRef } from 'react';

export default function HallTicketPage() {
  const [RegMobile, setRegMobile] = useState('');
  const [submittedData, setSubmittedData] = useState(null);
  const pdfRef = useRef();

  // Example submit handler with enhanced debugging & error handling
  async function downloapdfsubmit(e)
  {
    e.preventDefault();
    const mobile={RegMobile};
  console.log(mobile);   
  
  upscprelimsApiserviceget(mobile)
  .then((response) => {
    console.log("API Response:", response);
   console.log("API Response:", response.value);
    if(response.success===false)
    {
      alert(response.message);
      //document.getElementById("mobileNumber").reset();
    }
    else{
      setSubmittedData(response.value)
    }
   
  });
  console.log(mobile);
  //setSubmittedData(); 
  }

  // Handle PDF generation using html2canvas and jsPDF
  const generatePDF = async () => {
    if (typeof window === "undefined") return; // ensures we're in the browser
  
    const html2pdf = (await import("html2pdf.js")).default;
    const input = pdfRef.current;
    const opt = {
      margin: 10,
      filename: "hallticket.pdf",
      image: { type: "jpeg", quality: 0.50 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" }
    };
  
    html2pdf().set(opt).from(input).save().catch((error) => {
      console.error("Error generating PDF:", error);
    });
  };
  

  return (
    <>
      <Navbar title="home" />
      <h4 className="pt-5 pb-4 text-center" style={{ fontFamily: "Switzer-Bold" }}>
        UPSC Prelims Mock Test Hall Ticket 2025
      </h4>
      <div className="container p-4" style={{ backgroundColor: "#fff8ea" }}>
        {/* Form to submit Mobile Number */}
        <form onSubmit={downloapdfsubmit} className="mobile-label mb-4 col-md-6 mx-auto">
          <label htmlFor="mobileNumber">Enter your Register Mobile Number:</label>
          <input
            type="tel"
            name="mobileNumber"
            id="mobileNumber"
            required
            value={RegMobile}
            onChange={(e) => setRegMobile(e.target.value)}
            className="form-control mobile-input"
          />
          <button type="submit" className="btn btn-primary mt-3">
            Submit
          </button>
        </form>
      </div>

      { submittedData && (
        <div className="container mt-4 pt-4">
          {/* Button to Generate PDF */}
          <button type="button" onClick={generatePDF} className="download-button">
            Download Hall Ticket
          </button>

          
          <div className="col-12">
  <div ref={pdfRef} className="mt-4 p-4 border rounded-lg bg-gray-600">
    <div className="row">
      {/* Logo Section */}
      <div className="col-4 col-md-4 d-flex justify-content-start align-items-center pt-4">
        <Image
          src={Logo}
          alt="shankar ias logo"
          title="Shankar IAS Academy"
          className="img-fluid"
          style={{ width: '300px', height: 'auto' }}

        />
      </div>

      {/* Title Section */}
      <div className="col-8 col-md-8 d-flex  align-items-center pt-4">
        <div>
          <h5 className="text-center" style={{ fontFamily: "Switzer-Bold" }}>
            UPSC Prelims Mock Test - 2025
          </h5>
          <h5 className="text-center" style={{ fontFamily: "Switzer-Bold" }}>
            Hall Ticket
          </h5>
        </div>
      </div>
    </div>

    {/* Form Section */}
    <div className="formsection">
      <div className="fields">
        <table className="table">
          <thead>
            <tr>
              <th>Required Field</th>
              <th>Candidate Details</th>
              <th>Candidate’s Photo</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Name of the Candidate:</td>
              <td>
                <span className="input-field">{submittedData.name}</span>
              </td>
              <td rowSpan="7" className="photo">
                <img
                  src={submittedData.passport_photo}
                  alt="Uploaded"
                  className="mt-2 object-cover border rounded"
                  style={{ width: "150px", height: "150px" }}
                />
              </td>
            </tr>
            <tr>
              <td>SIA Roll Number:</td>
              <td>
                <span className="input-field">{submittedData.sia_registerno}</span>
              </td>
            </tr>
            <tr>
              <td>Mobile No:</td>
              <td>
                <span className="input-field">{submittedData.phone_no}</span>
              </td>
            </tr>
            <tr>
              <td>Mode of Exam:</td>
              <td>
                <span className="input-field">{submittedData.mode}</span>
              </td>
            </tr>
            <tr>
              <td>Centre Name:</td>
              <td>
                <span className="input-field">{submittedData.center}</span>
              </td>
            </tr>
            <tr>
              <td>Venue:</td>
              <td>
                <span className="input-field">{submittedData.center}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <h6 className="pt-1" style={{ fontFamily: "Switzer-Bold" }}>
      MOCK TEST DATE AND TIME
    </h6>

    <div className="formsection">
      <div className="fields">
        <table className="table">
          <thead>
            <tr>
              <th>TEST</th>
              <th>DATE</th>
              <th>PAPER I</th>
              <th>PAPER II</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Mock Test 1</td>
              <td>
                <span className="input-field">04.5.2025</span>
              </td>
              <td>
                <span className="input-field">9.30am-11.30am</span>
              </td>
              <td>
                <span className="input-field">2.30pm-4.30pm</span>
              </td>
            </tr>
            <tr>
              <td>Mock Test 2</td>
              <td>
                <span className="input-field">11.5.2025</span>
              </td>
              <td>
                <span className="input-field">9.30am-11.30am</span>
              </td>
              <td>
                <span className="input-field">2.30pm-4.30pm</span>
              </td>
            </tr>
            <tr>
              <td>Mock Test 3</td>
              <td>
                <span className="input-field">18.5.2025</span>
              </td>
              <td>
                <span className="input-field">9.30am-11.30am</span>
              </td>
              <td>
                <span className="input-field">2.30pm-4.30pm</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <h6 className="" style={{ fontFamily: "Switzer-Bold" }}>
      Note: For Offline Students:
    </h6>
    <ul>
      <li>Candidates are requested to assemble at mock test venue before 30 mins.</li>
      <li>Use black ball point to shade the OMR sheets.</li>
      <li>
        For the following centers (Annanagar, Delhi, Bengaluru) the mock test allotted venue will be shared
        through mail/sms before a day.
      </li>
      <li>
        Offline students should bring this hall ticket for all the three mock test along with original UPSC
        hall ticket (if published by UPSC). Otherwise, the candidate will not be permitted to attend the test.
      </li>
      <li>Online students should upload the original UPSC hall ticket if published.</li>
    </ul>
    <h5 className="text-end p-2">Signature of the Candidate</h5>

        </div>
        </div>
        </div>
        
      )}

      {/* Scoped CSS using JSX */}
      <style jsx>{`
        .container {
          width: 100%;
          max-width: 900px;
          margin: 0 auto;
          background-color: white;
          padding: 20px;
          border-radius: 10px;
          box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
        }
        .formsection {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 2rem;
        }
        .fields {
          width: 100%;
        }
        .table {
          width: 100%;
          border-collapse: collapse;
        }
        .table td {
          border: 1px solid #00000069;
          padding: 0.5rem;
          background-color: #ffffff;
          color: #161414;
        }
        th {
          font-family: "Switzer-Bold";
          border: 1px solid #00000069;
          padding: 0.5rem;
          background-color: #f2f2f2;
        }
        .input-field {
          font-family: Switzer-Medium;
        }
        .photo {
          text-align: center;
        }
        .download-button {
          background-color: red;
          color: white;
          padding: 0.5rem 1rem;
          border: none;
          border-radius: 0.25rem;
          cursor: pointer;
          transition: background-color 0.3s ease;
        }
        .download-button:hover {
          background-color: darkred;
        }

         .mobile-label {
          display: block;
          font-size: 16px;
           margin:10px;
       }
        .mobile-input {
        
          font-size: 16px;
          border: 1px solid #ccc;
          border-radius: 4px;
          width: 100%;
          box-sizing: border-box;
              margin: 10px 0px;
        }
          /* Mobile-specific styles */
  @media (max-width: 600px) {
    .container {
      padding: 10px;
      margin: 0 10px;
    }
    .formsection {
      flex-direction: column;
    }
    .table td,
    th {
      font-size: 14px;
      padding: 0.3rem;
    }
    .download-button {
      padding: 0.4rem 0.8rem;
      font-size: 14px;
    }
  }
      `}</style>

      <Footer />
    </>
  );
}
